export default __webpack_public_path__ + "static/media/game.2416bb55.gif";